export const Config = {
  i18n: {
    locale: "en-US",
    currency: "SAR",
  },
} as const;
